const roles = [
   "host",
   "admin",
   "user"
];

export default roles;